import { render, staticRenderFns } from "./mine_old.vue?vue&type=template&id=44e2181b&scoped=true"
import script from "./mine_old.vue?vue&type=script&lang=js"
export * from "./mine_old.vue?vue&type=script&lang=js"
import style0 from "./mine_old.vue?vue&type=style&index=0&id=44e2181b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2181b",
  null
  
)

export default component.exports